import { useParams } from 'react-router-dom';
import {
  getConnection,
  getColor,
  getMode,
} from '../../utils/analyzerStatusUtils';
import {
  Grid,
  Paper,
  TableContainer,
  Table,
  Typography,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import {
  getAnalyzerTypeName,
  getManufacturerFromType,
} from '../../utils/analyzerTypes';
import { useLocationByAnalyzer } from 'features/locations/api/getLocationByAnalyzer';

import { useAnalyzer } from 'features/analyzers/api/getAnalyzer';
import { useAnalyzerModules } from 'features/analyzerModules/api/getAnalyzerModules';

export const AnalyzerPage = () => {
  const { id: analyzerId } = useParams<'id'>();
  const analyzerIdNum = Number(analyzerId);
  const { data: location } = useLocationByAnalyzer({
    analyzerId: analyzerId ? Number(analyzerId) : -1,
  });
  const { data: selectedAnalyzer } = useAnalyzer({ analyzerId: analyzerIdNum });
  const { data: modules } = useAnalyzerModules({});

  return (
    <Grid container direction='column' spacing={2}>
      <Grid item>
        <Typography variant='h5'>Device Details</Typography>
      </Grid>
      <Grid item>
        <TableContainer component={Paper} style={{ width: '600px' }}>
          <Table sx={{ minWidth: 600 }} aria-label='simple table'>
            <TableBody>
              <TableRow
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component='th' scope='row'>
                  Device Name
                </TableCell>
                <TableCell>{selectedAnalyzer?.name}</TableCell>
              </TableRow>
              <TableRow
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component='th' scope='row'>
                  Device Type
                </TableCell>
                <TableCell>
                  {getAnalyzerTypeName(selectedAnalyzer?.type)
                    ? 'Spectrum Analyzer'
                    : 'Other'}
                </TableCell>
              </TableRow>
              <TableRow
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component='th' scope='row'>
                  Unit Type
                </TableCell>
                <TableCell>
                  {getAnalyzerTypeName(selectedAnalyzer?.type)}
                </TableCell>
              </TableRow>
              <TableRow
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component='th' scope='row'>
                  Manufacturer
                </TableCell>
                <TableCell>
                  {getManufacturerFromType(selectedAnalyzer?.type)}
                </TableCell>
              </TableRow>
              <TableRow
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component='th' scope='row'>
                  Number of Ports
                </TableCell>
                <TableCell>{selectedAnalyzer?.number_of_ports}</TableCell>
              </TableRow>
              <TableRow
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component='th' scope='row'>
                  Serial Number
                </TableCell>
                <TableCell>{selectedAnalyzer?.serial}</TableCell>
              </TableRow>
              <TableRow
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component='th' scope='row'>
                  Address
                </TableCell>
                <TableCell>{selectedAnalyzer?.ip}</TableCell>
              </TableRow>
              <TableRow
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component='th' scope='row'>
                  Connection Status
                </TableCell>
                <TableCell>
                  <Typography
                    variant='subtitle2'
                    style={{ color: getColor(selectedAnalyzer) }}
                  >
                    {getConnection(selectedAnalyzer)}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component='th' scope='row'>
                  Mode
                </TableCell>
                <TableCell>{getMode(selectedAnalyzer)}</TableCell>
              </TableRow>
              <TableRow
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component='th' scope='row'>
                  Modules
                </TableCell>
                <TableCell>
                  {modules
                    ?.find(
                      (module) => module.analyzer_id === selectedAnalyzer?.id
                    )
                    ?.types.join(', ')}
                </TableCell>
              </TableRow>
              <TableRow
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component='th' scope='row'>
                  Location
                </TableCell>
                <TableCell>{location?.name ? location.name : 'None'}</TableCell>
              </TableRow>
              <TableRow
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component='th' scope='row'>
                  Notes
                </TableCell>
                <TableCell>{selectedAnalyzer?.memo}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
